/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateWorkloadIssuerForm,
  UpdateWorkloadIssuerForm$Outbound,
  UpdateWorkloadIssuerForm$outboundSchema,
} from "../components/updateworkloadissuerform.js";

export type UpdateWorkloadIssuerSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type UpdateWorkloadIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateWorkloadIssuerSecurity = {
  option1?: UpdateWorkloadIssuerSecurityOption1 | undefined;
  option2?: UpdateWorkloadIssuerSecurityOption2 | undefined;
};

export type UpdateWorkloadIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateWorkloadIssuerForm: UpdateWorkloadIssuerForm;
};

/** @internal */
export type UpdateWorkloadIssuerSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateWorkloadIssuerSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateWorkloadIssuerSecurityOption1$Outbound,
  UpdateWorkloadIssuerSecurityOption1
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateWorkloadIssuerSecurityOption1ToJSON(
  updateWorkloadIssuerSecurityOption1: UpdateWorkloadIssuerSecurityOption1,
): string {
  return JSON.stringify(
    UpdateWorkloadIssuerSecurityOption1$outboundSchema.parse(
      updateWorkloadIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateWorkloadIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateWorkloadIssuerSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateWorkloadIssuerSecurityOption2$Outbound,
  UpdateWorkloadIssuerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateWorkloadIssuerSecurityOption2ToJSON(
  updateWorkloadIssuerSecurityOption2: UpdateWorkloadIssuerSecurityOption2,
): string {
  return JSON.stringify(
    UpdateWorkloadIssuerSecurityOption2$outboundSchema.parse(
      updateWorkloadIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateWorkloadIssuerSecurity$Outbound = {
  Option1?: UpdateWorkloadIssuerSecurityOption1$Outbound | undefined;
  Option2?: UpdateWorkloadIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateWorkloadIssuerSecurity$outboundSchema: z.ZodMiniType<
  UpdateWorkloadIssuerSecurity$Outbound,
  UpdateWorkloadIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateWorkloadIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateWorkloadIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateWorkloadIssuerSecurityToJSON(
  updateWorkloadIssuerSecurity: UpdateWorkloadIssuerSecurity,
): string {
  return JSON.stringify(
    UpdateWorkloadIssuerSecurity$outboundSchema.parse(
      updateWorkloadIssuerSecurity,
    ),
  );
}

/** @internal */
export type UpdateWorkloadIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateWorkloadIssuerForm: UpdateWorkloadIssuerForm$Outbound;
};

/** @internal */
export const UpdateWorkloadIssuerRequest$outboundSchema: z.ZodMiniType<
  UpdateWorkloadIssuerRequest$Outbound,
  UpdateWorkloadIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateWorkloadIssuerForm: UpdateWorkloadIssuerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateWorkloadIssuerForm: "UpdateWorkloadIssuerForm",
    });
  }),
);

export function updateWorkloadIssuerRequestToJSON(
  updateWorkloadIssuerRequest: UpdateWorkloadIssuerRequest,
): string {
  return JSON.stringify(
    UpdateWorkloadIssuerRequest$outboundSchema.parse(
      updateWorkloadIssuerRequest,
    ),
  );
}
